export interface LoadState<T> {
  loading: boolean;
  loadSuccess: boolean;
  loadFailed: boolean;
  errorMessage?: string;
  data: T;
}

export class LoadStateInitialValue<T> implements LoadState<T>{
  loading = false;
  loadSuccess = false;
  loadFailed = false;
  data: T;

  constructor(data: T = null) {
    this.data = data;
  }
}
